var exports = {
  "k": "x31de4314--6d33f8--container",
  "V": "x31de4314--6d33f8--subtitle",
};

module.exports = exports;
